import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { provideAuth0, authHttpInterceptorFn } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';

import { routes } from './routes.config';
import { apiEndpoints } from './api-endpoints.config';
import { selectedCegInterceptor } from '../interseptors/selected-ceg.interceptor';
// import { requestLoggerInterceptor } from './requestLogger.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
        provideAuth0({
            ...environment.auth0,
            httpInterceptor: {
                allowedList: [
                    `${apiEndpoints.paciens}`,
                    `${apiEndpoints.paciens}/*`,
                    `${apiEndpoints.auth}/*`,
                    `${apiEndpoints.komplexum}`,
                    `${apiEndpoints.komplexum}/*`,

                    // ide jön a többi protected endpoints. Ami nincs itt felsorolva, az nem kapja meg az access tokent!
                ],
            },
        }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
        withFetch(),
        withInterceptors([authHttpInterceptorFn, selectedCegInterceptor]),
        // withInterceptors([authHttpInterceptorFn, requestLoggerInterceptor])
    ),
  ]
};
